module.exports = {
    values: {
        REALTIME_TYPE_DESCRIPTION:
            'A always running query that will add values to the list stored on the chosen "key".',
        HISTORICAL_TYPE_DESCRIPTION:
            'A query that will run based on a time schedule given with the provided parameters, keys are stored as output by the query.'
    }
}
